module.exports = __webpack_public_path__ + "static/media/frutiger-65bold.957d1e80.ttf";